import { create } from "zustand";

interface SuggestionDevState {
  includeInventory: boolean;
  setIncludeInventory: (value: boolean) => void;
  applyPreFilter: boolean;
  setApplyPreFilter: (value: boolean) => void;
  forceReload: boolean;
  setForceReload: (value: boolean) => void;
}

export const useSuggestionDevStore = create<SuggestionDevState>((set) => ({
  includeInventory: true,
  setIncludeInventory: (value) => set({ includeInventory: value }),
  applyPreFilter: true,
  setApplyPreFilter: (value) => set({ applyPreFilter: value }),
  forceReload: false,
  setForceReload: (value) => set({ forceReload: value }),
}));
